























































































































































/* eslint-disable */
import Vue from "vue";
import { decode } from 'html-entities';
import { getYear } from 'date-fns';
import gsap from 'gsap';
import { printError } from '@/lib/utils';
import { Month, MonthEvent } from '@/lib/types';
import api from '@/lib/api';
import CoolInput from '@/components/ui/CoolInput.vue';

export default Vue.extend({ 
	components: { 'cool-input': CoolInput },
	async mounted(){

		this.month = await api.telegram.calendar.getCurrentMonth();
		console.log(this.month);
		
		for(const day in this.month.month){

			this.month.month[day].forEach(ev => { 
				ev.event_description = decode(ev.event_description) 
				ev.event_name = decode(ev.event_name);
			})

		}
		this.current_index = this.month.month_info.starting_day;

	},
	methods: {
		format(str: string){
			return str.replace(/\|(.*?)\|\((.*?)\)/g, "<a href='$1'>$2</a>").replace(new RegExp("__(.*?)__", "g"), "<i>$1</i>").replace(new RegExp("\\*\\*(.*?)\\*\\*", "g"), "<b>$1</b>").replace(new RegExp("##(.*?)##", "g"), "<u>$1</u>")
		},
		updateEventName(val: { text: string, id: number }){
			this.event_name = val.text;
			console.log(this.event_name);
		},
		showAddModal(){		
			this.current_modal = '#add-event';	
			gsap.to('#add-event', {
				duration: .25,
				opacity: 1,
				pointerEvents: 'all'
			})
		},
		showEditModal(e: MonthEvent, ei: number){		
			this.current_modal = '#edit-event';	
			gsap.to('#edit-event', {
				duration: .25,
				opacity: 1,
				pointerEvents: 'all'
			})
			this.event_name = e.event_name;
			this.event_start = e.event_starting_time;
			this.event_end = e.event_ending_time;
			this.event_description = e.event_description;
			this.event_id = e.event_id!;
			this.private_event = e.is_private;
			this.event_index = ei;
		},
		closeCurrentModal(){	
			gsap.to(this.current_modal, {
				duration: .25,
				opacity: 0,
				pointerEvents: 'none'
			})
			this.event_end = '';
			this.event_name = '';
			this.event_description = '';
			this.event_start = '';
			this.create_message = '';
			this.event_id = '';
			this.private_event = false;
		},
		goBack(){
			gsap.to('#edit-day', {
				transform: "translateY(100vh)",
				duration: .5
			});
		},
		loadDay(day: MonthEvent[], selected_index: number, current_number: number){
			
			this.current_day = day;
			this.current_day_number = current_number;
			this.selected_day = selected_index;
			gsap.to('#edit-day', {
				transform: "translateY(0)",
				duration: .5
			});
			
		},
		async editEvent() {
			const event_name = this.event_name,
				  event_description = this.event_description,
				  event_starting_time = this.event_start,
				  event_ending_time = this.event_end,
				  event_day_number = this.current_day_number,
				  event_day = this.selected_day,
				  event_id = this.event_id,
				  month_id = this.month.month_info.month_id,
				  is_private = this.private_event;
			const obj: MonthEvent = { event_name, event_description, event_starting_time, event_ending_time, event_day_number, event_day, event_id, is_private };
			try{
				await api.telegram.calendar.editEvent(month_id, obj);
				this.current_day[this.event_index] = obj;
				this.edit_message = "Evento modificato con successo!";
			}catch(err){
				this.edit_message = printError(err as Error, true);
			}
		},
		async deleteEvent(id: string, ei: number){
			if(!confirm("Vuoi eliminare questo evento?")) return;
			try{
				await api.telegram.calendar.deleteEvent(id);
				this.current_day.splice(ei, 1);
			}catch(err){
				printError(err as Error);
			}

		},
		async createEvent(){
			// console.log(this.event_name, this.event_description, this.event_start, this.event_end);
			const event_name = this.event_name,
				  event_description = this.event_description,
				  event_starting_time = this.event_start,
				  event_ending_time = this.event_end,
				  event_day_number = this.current_day_number,
				  event_day = this.selected_day,
				  is_private = this.private_event;
			const obj: MonthEvent = { event_name, event_description, event_starting_time, event_ending_time, event_day_number, event_day, is_private };
			try{
				let response = await api.telegram.calendar.addEvent(obj);
				let pieces = response.event_id.split("-");
				
				this.current_day.push({ event_id: pieces[1], month_id: pieces[0], ...obj});
				this.create_message = "Evento creato con successo!";
			}catch(err){
				this.create_message = printError(err as Error, true);
			}
		},
	},
	data(){
		
		return {
			normal_days: [
				'domenica',
				'lunedì',
				'martedì',
				'mercoledì',
				'giovedì',
				'venerdì',
				'sabato'
			],
			current_index: 0,
			month: {} as Month,
			current_day: [] as MonthEvent[],
			selected_day: 0,
			current_day_number: 1,
			current_year: getYear(new Date()),
			event_name: '',
			event_description: '',
			event_start: '',
			event_end: '',
			current_modal: '',
			create_message: '',
			edit_message: '',
			event_id: '',
			event_index: -1,
			private_event: false
		}
		
	}
});
